/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonAddressSummaryInfo } from './BabylonAddressSummaryInfo';

export type BabylonProposalVoteStakerInfo = {
    STK: BabylonAddressSummaryInfo;
    VTP: BabylonProposalVoteStakerInfo.VTP;
    VTRXHASH: string;
    AGE: string;
    UT: number;
};

export namespace BabylonProposalVoteStakerInfo {

    export enum VTP {
        YES = 'YES',
        NO = 'NO',
        VETO = 'VETO',
        ABSTAIN = 'ABSTAIN',
    }


}

